module.exports = __webpack_public_path__ + "static/media/respMessage.e6ef201c.svg";